// extracted by mini-css-extract-plugin
export default {"container":"HeaderNavigationItem_container__Pt7yh","text":"HeaderNavigationItem_text__mColk"};